<template>
  <!-- Global display for system/error/success messages -->
  <v-snackbar
    v-model="systemMsg.isShownImmediately"
    :left="systemMsg.alignLeft"
    top
    multi-line
    transition="scale-transition"
    :color="systemMsg.type"
    :timeout="systemMsg.displayTime || 5000"
  >
    {{ systemMsg.message }}
    <template v-slot:action="{ attrs }">
      <v-btn color="white" text v-bind="attrs" @click="systemMsg.isShownImmediately = false">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'SystemMessage',
  props: {
    systemMessage: {
      type: Object,
    },
  },
  data() {
    return {
      systemMsg: {},
      emptySystemMsg: {
        isShownImmediately: false,
        type: '',
        message: '',
        displayTime: 5000,
      },
    }
  },
  mounted() {
    this.systemMsg = this.getLocalStorageMsg() || this.emptySystemMsg
  },
  watch: {
    systemMessage() {
      // if system message is set to not be shown but has a message,
      // this means the message is set to be shown later when another page
      // is loaded and this component is mounted again
      if (!this.systemMessage.isShownImmediately && this.systemMessage.message.length) {
        const localStorageSysMsg = { ...this.systemMessage, isShownImmediately: true }
        this.setLocalStorageMsg(localStorageSysMsg)
      } else {
        this.systemMsg = this.systemMessage
      }
    },
  },
  methods: {
    // Retrieves system message from localStorage. Once received, resets localStorage to empty message.
    getLocalStorageMsg() {
      const systemMsg = JSON.parse(localStorage.getItem('adaSystemMsg'))
      localStorage.setItem('adaSystemMsg', JSON.stringify(this.emptySystemMsg))
      return systemMsg
    },

    setLocalStorageMsg(systemMsg) {
      localStorage.setItem('adaSystemMsg', JSON.stringify(systemMsg))
    },
  },
}
</script>
